module.exports = __webpack_public_path__ + "static/img/dog.67143b5b.png";